import {
  ADVERTISEMENTS,
  ADVERTISEMENTS_MAX_PAYLOAD_SIZE,
  DEFAULT_API_ADMIN,
  MONEY_PRODUCTS,
  NOTIFICATION,
  PRODUCT,
  SMS,
  chainIdDelete,
  clearMaskRoutes,
  mapPath,
  routesWithUpload,
} from '../../constants'
import {
  addChainId,
  clearMask,
  getChainId,
  getUserId,
  httpClientReactAdmin,
  makePayloadWithFile,
} from '../../lib'
import { buildProductPlaces } from '../../lib/productPlaces'


const handleNotificationCreation = payload => {
  const _payload = {
    ...payload,
    employeeId: getUserId(),
    chainId: undefined,
  }

  return _payload
}

const handlePayload = (resourceName, data) => {
  const CLEAR_MASK = clearMaskRoutes.includes(resourceName)
  const HAS_CHAIN_ID = !chainIdDelete.includes(resourceName)
  const HAS_UPLOAD_FILE = routesWithUpload.includes(resourceName) || 'imagefile' in data

  let payload = data
  const payloadSize = JSON.stringify(payload).length;

  // Check payload size before sending
  if (resourceName === ADVERTISEMENTS && payloadSize > ADVERTISEMENTS_MAX_PAYLOAD_SIZE) {
    throw new Error(`Tamanho máximo de arquivo excedido.`);
  }

  if (resourceName === PRODUCT) {
    payload = {
      ...payload,
      places: buildProductPlaces(payload.places),
      isCash: false,
    }
    delete payload.defaultValue
    delete payload.partnerPrice
  }

  // Produto em dinheiro bate no mesmo endpoint de produto, mas com isCash = true e
  // apenas os campos que fazem sentido para ele. O transform da tela já normalizou
  // name/cashValue/places — aqui só garantimos a flag e removemos o resto.
  if (resourceName === MONEY_PRODUCTS) {
    payload = {
      ...payload,
      isCash: true,
      cashValue: +payload.cashValue,
      places: (payload.places || []).map(({ placeId, price, partnerPrice }) => ({
        placeId,
        price,
        partnerPrice: partnerPrice ? +partnerPrice : null,
      })),
    }
    delete payload.defaultPrice
  }

  if (CLEAR_MASK) {
    payload = clearMask(payload, ['phone', 'cellphone', 'cnpj'])
  }

  if (HAS_CHAIN_ID) {
    payload = addChainId(payload, resourceName)
  }

  if (HAS_UPLOAD_FILE) {
    payload = makePayloadWithFile(payload, ['logo', 'image', 'imagefile', 'serviceAccount', 'files', 'file', 'productImageFile', 'productImages', 'dotzCertificate', 'bbCertificate', 'previewfile'])
  }

  if (resourceName === NOTIFICATION || resourceName === SMS) {
    payload = handleNotificationCreation(payload)
  }

  return payload
}

// Recursos POST que precisam de chainId na query string (ex: forçar recompute do rollup do Painel 360)
const RESOURCES_WITH_CHAIN_ID_QUERY = ['dashboard-v2/refresh']

export default async (resourceName, { data }) => {
  const path = mapPath[resourceName] || resourceName;
  const hasUploadFile = routesWithUpload.includes(path) || 'imagefile' in data
  const chainIdQuery = RESOURCES_WITH_CHAIN_ID_QUERY.includes(path)
    ? `?chainId=${encodeURIComponent(getChainId())}`
    : ''
  const URL = `${DEFAULT_API_ADMIN}/${(path || '').replace(
    'chainId',
    getChainId(),
  )}${chainIdQuery}`

  const body = hasUploadFile ? handlePayload(resourceName, data) : JSON.stringify(handlePayload(resourceName, data))
  const { json } = await httpClientReactAdmin(URL, { method: 'POST', body }, !!hasUploadFile)

  return json
}
